import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Services from './components/Services';
import Portfolio from './components/Portfolio';
import Concept from './components/Concept';
import Testimonial from './components/Testimonial';
import News from './components/News';
import CTA from './components/CTA';
import Footer from './components/Footer';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="w-full px-8 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center">
                <i className="ri-brush-line text-3xl text-gray-900"></i>
              </div>
              <span className="text-xl font-bold text-gray-900" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>絵 仕事</span>
            </div>
            <div className="flex items-center gap-8">
              <a href="#services" className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors whitespace-nowrap cursor-pointer">サービス</a>
              <a href="#portfolio" className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors whitespace-nowrap cursor-pointer">ポートフォリオ</a>
              <a href="#concept" className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors whitespace-nowrap cursor-pointer">コンセプト</a>
              <a href="#news" className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors whitespace-nowrap cursor-pointer">ニュース</a>
              <a href="#contact" className="px-6 py-2.5 bg-gray-900 text-white text-sm font-medium rounded-full hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer">お問い合わせ</a>
            </div>
          </div>
        </div>
      </nav>

      <Hero />
      <Services />
      <Portfolio />
      <Concept />
      <Testimonial />
      <News />
      <CTA />
      <Footer />
    </div>
  );
}